export const SwfSelector = {
    oldSwfSelector: ".share-article-container",
};
